export const formatRating = (rating: number) =>
    (Math.round(rating * 100) / 100).toPrecision(2)

export const formatDistance = (distance: number) => {
    if (distance < 1000) return Math.round(distance)

    if (distance < 10000) return (distance / 1000).toFixed(2)

    return Math.round(distance / 1000)
}

export const getSafeName = (name: string) =>
    name
        .replace(/ /g, '-')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036F]/g, '')

export const toPascalCase = (name: string | null) =>
    name ? name.charAt(0).toUpperCase() + name.slice(1) : ''

export const toCamel = (s: string): string =>
    s.replace(/([_]([a-z]|[1-9]))/gi, ($1) => $1.toUpperCase().replace('_', ''))

export const keysToCamel = (o: any): any => {
    if (o === Object(o) && !Array.isArray(o) && typeof o !== 'function') {
        const n: any = {}
        Object.keys(o).forEach((k) => {
            n[toCamel(k)] = keysToCamel(o[k])
        })

        return n
    }

    if (Array.isArray(o)) {
        return o.map((i) => keysToCamel(i))
    }

    return o
}

export const toSnake = (s: any) =>
    s
        .split(/(?=[A-Z]|[1-9])/)
        .join('_')
        .toLowerCase()

export const keysToSnake = (o: any): any => {
    if (o === Object(o) && !Array.isArray(o) && typeof o !== 'function') {
        const n: any = {}
        Object.keys(o).forEach((k) => {
            n[toSnake(k)] = keysToSnake(o[k])
        })

        return n
    }

    if (Array.isArray(o)) {
        return o.map((i) => keysToSnake(i))
    }

    return o
}
